import configDataFn from '@/baseData/maintenance/manageList'
import { operateMaxShowLength } from '@/store/dict/config'

export default function () {
  const jumpDetail = (query) => {
    this.$router.push({
      path: '/driver/customerManage/detail',
      query,
    })
  }
  const operate = {
    name: 'operate',
    columnProps: {
      label: '操作',
      width: 240,
      fixed: 'right',
    },
    type: 'operate',
    maxShowLength: operateMaxShowLength,
    getOperateList: ({ row }) => {
      const operateList = [
        { name: 'detail', label: '详情', action: () => jumpDetail({ id: row.id, tabType: 'maintenance' }) },
      ]
      return operateList
    },
  }
  const { configData } = configDataFn.call(this, { dealWithData: this.dealWithData })
  configData.tableData.columns.push(operate)
  configData.formData.exportData = {
    exportTemplate: 'Maintenance',
    filename: '维保管理列表.xlsx',
    permissionName: 'driver_customer_list_detail',
  }
  return { configData }
}
